import { ClientException } from 'src/core/common/domain/exceptions/client-exception';
import { GenericClientException } from 'src/core/common/domain/exceptions/generic-client-exception';
import { NfcTagCapacityExceededException } from 'src/core/common/domain/exceptions/nfc-tag-capacity-exceeded-exception';
import { NfcTagLostException } from 'src/core/common/domain/exceptions/nfc-tag-lost-exception';
import { NfcTagNotSupportedException } from 'src/core/common/domain/exceptions/nfc-tag-not-supported-exception';
import { NfcTagReadOnlyException } from 'src/core/common/domain/exceptions/nfc-tag-read-only-exception';

// The messages below are the literal ones community-cordova-plugin-nfc rejects a write with
// (NfcPlugin.writeNdefMessage). Should a plugin update reword them, those failures become generic ones.
export class NfcWriteErrorParser {
  private static readonly CAPACITY_EXCEEDED = /Tag capacity is (\d+) bytes, message is (\d+) bytes/;
  private static readonly READ_ONLY = 'Tag is read only';
  private static readonly NOT_SUPPORTED = "Tag doesn't support NDEF";
  // A tag moved away mid-write surfaces as a TagLostException or an IOException, often without any message.
  private static readonly TAG_LOST = /lost|expired|transceive|I\/O/i;

  static toException(error: unknown): ClientException {
    const message = NfcWriteErrorParser.messageOf(error);

    const capacity = NfcWriteErrorParser.CAPACITY_EXCEEDED.exec(message);
    if (capacity) {
      return new NfcTagCapacityExceededException(Number(capacity[1]), Number(capacity[2]), message);
    }

    if (message === NfcWriteErrorParser.READ_ONLY) {
      return new NfcTagReadOnlyException(message);
    }

    if (message === NfcWriteErrorParser.NOT_SUPPORTED) {
      return new NfcTagNotSupportedException(message);
    }

    if (message === '' || NfcWriteErrorParser.TAG_LOST.test(message)) {
      return new NfcTagLostException(message);
    }

    return new GenericClientException(message);
  }

  private static messageOf(error: unknown): string {
    if (typeof error === 'string') {
      return error;
    }

    if (error instanceof Error) {
      return error.message;
    }

    return '';
  }
}
